"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeFetchableRaceError = exports.IkeFetchableTransform = exports.IkeFetchableOne = exports.IkeFetchableMany = exports.IkeFetchableBase = exports.IkeFetchableStore = void 0;
exports.lastFetchObjectOrNow = lastFetchObjectOrNow;
const tslib_1 = require("tslib");
const array_1 = require("../util/array");
class IkeFetchableStore {
    constructor() {
        this.error = null;
        this.promise = null;
        this.isFetching = false;
    }
    setIsFetching(isFetching) {
        this.isFetching = isFetching;
    }
    setValue(value, lastFetch) {
        this.value = value;
        this.lastFetch = lastFetch;
        this.isFetching = false;
    }
    setError(error) {
        this.error = error;
        this.isFetching = false;
    }
}
exports.IkeFetchableStore = IkeFetchableStore;
class IkeFetchableBase {
    constructor(log, store, query) {
        this.log = log;
        this.query = query;
        this.store = store;
    }
    get hasFetched() {
        return this.store.lastFetch != null;
    }
    get isFetching() {
        return this.store.isFetching;
    }
    get lastFetch() {
        return this.store.lastFetch;
    }
    get error() {
        return this.store.error;
    }
    /**
     * @deprecated Using this getter incorrectly creates race conditions.
     * Use async {@link fetch} instead, or check {@link isFetching} and {@link error} in a loop until the fetch completes.
     */
    get value() {
        var _a, _b;
        if (this.hasFetched) {
            if (this.store.error) {
                return null;
            }
            return (_a = this.store.value) !== null && _a !== void 0 ? _a : null;
        }
        if (!this.isFetching) {
            this.fetch().catch((error) => {
                // We must catch and log here, otherwise the uncaught exception may crash the server.
                this.log.error({ error }, 'Fetchable: caught error in value getter');
            });
        }
        return (_b = this.store.value) !== null && _b !== void 0 ? _b : null;
    }
    /**
     * Re-query the fetchable
     */
    refetch() {
        this.store.promise = null;
        return this.fetch();
    }
    /**
     * Clear the fetchable value.
     * The fetchable will be re-queried next time it is used.
     */
    reset() {
        this.store.promise = null;
        this.store.setValue(null, null);
    }
    fetch() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.store.promise != null) {
                return yield this.store.promise;
            }
            this.store.promise = this.query()
                .then((obj) => {
                this.init(obj);
                return obj;
            })
                .catch((e) => {
                this.store.setError(e);
                throw e;
            });
            this.store.setIsFetching(true);
            return yield this.store.promise;
        });
    }
}
exports.IkeFetchableBase = IkeFetchableBase;
class IkeFetchableMany extends IkeFetchableBase {
    constructor() {
        super(...arguments);
        this.mapByKey = {};
    }
    get first() {
        const value = this.value;
        if (value != null) {
            return value[0];
        }
        return null;
    }
    find(key, value) {
        if (this.value == null) {
            return null;
        }
        if (typeof value !== 'string') {
            throw new Error(`Unable to lookup by value which is not a string typeof:${typeof value}`);
        }
        let map = this.mapByKey[key];
        if (map == null) {
            map = this.mapByKey[key] = array_1.IkeArray.toMap(this.value, key);
        }
        // TODO is there a better way to fix this
        return map[value];
    }
    /**
     * Set a initial value for this fetchable,
     * Last fetch time will use the updatedAt of the objector
     * the current time depending on which is newer.
     */
    init(value) {
        this.mapByKey = {};
        this.store.setValue(value, this.lastUpdatedAt(value));
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    }
    lastUpdatedAt(value) {
        if (value == null || value.length === 0) {
            return Date.now();
        }
        let lastObj = null;
        for (const v of value) {
            if (lastObj == null || lastObj.updatedAt < v.updatedAt) {
                lastObj = v;
            }
        }
        return lastFetchObjectOrNow(lastObj);
    }
}
exports.IkeFetchableMany = IkeFetchableMany;
/**
 * Last fetch should be set to the current time,
 * but sometimes user's clocks are off, so use the server time if that
 * is ahead other wise use the user's time
 */
function lastFetchObjectOrNow(obj) {
    const currentTime = Date.now();
    if (obj == null || obj.updatedAt == null) {
        return currentTime;
    }
    const updatedAt = new Date(obj.updatedAt).getTime();
    const timeDiff = updatedAt - currentTime;
    if (timeDiff > 0) {
        return updatedAt;
    }
    return currentTime;
}
class IkeFetchableOne extends IkeFetchableBase {
    /**
     * Set a initial value for this fetchable
     * Last fetch time will use the updatedAt of the object or
     * the current time depending on which is newer.
     */
    init(value) {
        this.store.setValue(value, lastFetchObjectOrNow(value));
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    }
}
exports.IkeFetchableOne = IkeFetchableOne;
class IkeFetchableTransform extends IkeFetchableBase {
    constructor(log, store, base, transform) {
        super(log, store, () => base.fetch().then((obj) => this.transform(obj)));
        this.base = base;
        this.transform = transform;
    }
    init(value) {
        this.store.setValue(value, Date.now());
        this.store.promise = Promise.resolve(this.store.value);
        this.store.setError(null);
    }
}
exports.IkeFetchableTransform = IkeFetchableTransform;
/**
 * Thrown when an access to IkeFetchable.value fails due to a race condition.
 */
class IkeFetchableRaceError extends Error {
}
exports.IkeFetchableRaceError = IkeFetchableRaceError;
//# sourceMappingURL=fetchable.js.map